import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { publicToolHead } from "@/lib/publicToolRoutes";

const Page = () => <Index toolKey="agent" routeLang="es" />;

export const Route = createFileRoute("/agente-retail-ia")({
  head: () => publicToolHead("agent", "es"),
  component: Page,
  errorComponent: Page,
  notFoundComponent: Page,
});
